import React from 'react'
import PaperBase from '../Paper/PaperBase'
import { Typography } from '@mui/material'
import IconTooltipButton from '../button/IconTooltipButton'
import ListInGS from '../list/ListInGS'
import { useSelector } from 'react-redux'

const ButtonElement = ({ list, actions, icon, title, id, expandDefault = false }) => {
  const [expand, setExpand] = React.useState(expandDefault)

  const onToggleExpand = (e) => {
    e.stopPropagation()
    setExpand(!expand)
  }
  const style = {
    color: 'var(--accent)',
    backgroundColor: expand ? 'var(--accent-foreground)' : 'white',
    border: '1px solid var(--accent)',
    width: 22,
    height: 22
    // borderRadius: 4,
    // borderBottomRightRadius: 0,
    // borderBottomLeftRadius: 0
  }

  return (
    <>
      {list?.length > 0 && (
        <div className='flex gap-2 items-center justify-end w-full'>
          <IconTooltipButton
            icon={icon}
            title={title}
            onClick={onToggleExpand}
            classNameIcon='text-xs shadow'
            style={style}
          />
        </div>
      )}
      {expand && <ListInGS id={`list-worked-examples-${id}`} list={list || []} buttons={actions} />}
    </>
  )
}

const GranularStepCard = ({
  id,
  backgroundColor,
  color,
  className = '',
  step,
  actions,
  actionsWorkedExamples,
  actionsEvidenceOfLearning,
  actionsNote,
  actionsTeachingSuggestions,
  marking,
  onClick,
  ...props
}) => {
  const userRolesIds = useSelector((state) => state?.session?.user?.roles?.map((role) => role.id) || [])

  return (
    <PaperBase
      id={id}
      backgroundColor={backgroundColor}
      color={color}
      className={[
        'min-w-200px w-full text-ellipsis flex-col relative justify-between',
        step?.definition ? '' : 'bg-lines',
        className
      ].join(' ')}
      style={{
        minHeight: 50
      }}
      onClick={onClick}
      children={
        <>
          {actions && (
            <div className='flex justify-end absolute right-2 top-1 pl-2' style={{ backgroundColor }}>
              {actions}
            </div>
          )}
          <div className='w-full'>
            <div>
              <Typography className='text-ellipsis text-sm'>{step?.definition}</Typography>
              {step.code && (
                <Typography className='text-ellipsis font-bold text-xs'> {step.code} </Typography>
              )}
            </div>
            <div className='flex flex-col gap-1 w-full pt-2'>
              <ButtonElement
                id={id}
                list={step?.workedExamples}
                actions={actionsWorkedExamples}
                icon={['fas', 'file-check']}
                title='Worked Examples'
              />
              <ButtonElement
                id={id}
                list={step?.evidenceOfLearning}
                actions={actionsEvidenceOfLearning}
                icon='tasks'
                title='Evidence of Learning'
              />
              <ButtonElement
                id={id}
                list={step?.note}
                actions={actionsNote}
                icon={['fas', 'comment-alt-check']}
                title='Note'
              />
              {!['Parent', 'Student'].some((role) => userRolesIds.includes(role)) && (
                <ButtonElement
                  id={id}
                  list={step?.teachingSuggestions}
                  actions={actionsTeachingSuggestions}
                  icon={['fal', 'chalkboard-user']}
                  title='Teaching Suggestions'
                />
              )}
            </div>
          </div>
          {marking}
        </>
      }
      {...props}
    />
  )
}

export default GranularStepCard
